// Shared IA + global links for header and footer.

export const APP = {
  signIn: 'https://app.shopstar.co.za/users/sign_in',
  signUp: 'https://app.shopstar.co.za/users/sign_up',
  applyToSell: 'https://app.shopstar.co.za/apply-to-sell',
};

// Shopstar Go — the new platform (free to start) that sells the full range of
// product types from one page. We cross-sell it across the marketing site for
// sellers who need more than a physical-product shop. Single source of truth for
// the Go brand assets + destination URL, so the announcement bar, pricing card,
// pricing band and inline hints all stay consistent.
export const SHOPSTAR_GO = {
  baseUrl: 'https://www.shopstar.io',
  logo: '/marketing/logos/shopstar-go-full.png',
  logoAlt: 'Shopstar Go',
  // Go pink, sampled from the official Go logo. Light enough that the navy logo,
  // ink copy and navy CTA pill all read at high contrast on top of it.
  bg: '#ffe1ed',
  // Go has its own sign-up — a Shopstar (Classic) account isn't a Go account.
  // Shown on the pricing card/band and the free-start blog CTA. No trailing
  // period so it works as a standalone line or mid-sentence.
  separateNote: 'It’s a separate platform with its own sign-up',
  productTypes: [
    { name: 'Physical products', blurb: 'Sell apparel, art and goods to customers anywhere.' },
    { name: 'Digital downloads', blurb: 'Sell ebooks, music, presets, templates and software.' },
    { name: 'Bookings', blurb: 'Take bookings for classes, appointments and services.' },
    { name: 'Memberships', blurb: 'Run a paid community, club or recurring subscription.' },
    { name: 'Tickets', blurb: 'Sell tickets to workshops, gigs, markets and meet-ups.' },
  ],
};

// Build a UTM-tagged Shopstar Go link. `medium` identifies the placement (e.g.
// 'announcement_bar', 'pricing_card', 'pricing_band') so shopstar.io can
// attribute traffic per surface.
export const shopstarGoHref = (medium) =>
  `${SHOPSTAR_GO.baseUrl}/?utm_source=shopstar.co.za&utm_medium=${medium}&utm_campaign=shopstar_go`;

// Blog posts about starting for free, where Go (the actually-free platform) is
// a better fit than the Classic trial — BlogPost swaps its closing CTA to Go.
export const GO_CTA_POST_SLUGS = [
  'how-to-make-an-online-store-for-free-in-south-africa',
  'ten-free-tools-to-help-you-start-your-online-business',
];

// Sticky top promo bar for the Shopstar Go launch. Uses the shared Go brand
// assets above on a soft Go-pink ground.
export const ANNOUNCEMENT = {
  href: shopstarGoHref('announcement_bar'),
  logo: SHOPSTAR_GO.logo,
  logoAlt: SHOPSTAR_GO.logoAlt,
  tagline: 'Sell anything from one simple page.',
  taglineBold: 'anything', // emphasised word within the tagline
  cta: 'Learn more',
};

export const CONTACT = {
  email: 'support@shopstar.co.za',
  addressLines: ['Darters Road, Gardens', 'Cape Town, South Africa', '8001'],
};

export const SOCIALS = [
  { label: 'Instagram', href: 'https://www.instagram.com/shopstarza/?hl=en', icon: 'instagram' },
  { label: 'Facebook', href: 'https://www.facebook.com/shopstarza', icon: 'facebook' },
  { label: 'YouTube', href: 'https://www.youtube.com/channel/UCWaEcck4L8zsFCqkRgh9SUQ', icon: 'youtube' },
];

export const NAV = [
  { label: 'About', href: '/about' },
  { label: 'Pricing & Features', href: '/pricing-and-features' },
  { label: 'Showcase', href: '/our-featured-shops' },
  { label: 'Contact', href: '/contact' },
];

export const FOOTER_COLUMNS = [
  {
    title: 'Product',
    links: [
      { label: 'Pricing & Features', href: '/pricing-and-features' },
      { label: 'Showcase', href: '/our-featured-shops' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'About', href: '/about' },
      { label: 'Blog', href: '/blog' },
      { label: 'Help Center', href: '/help-center' },
      { label: 'Contact', href: '/contact' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Terms & Conditions', href: '/terms-conditions' },
      { label: 'Privacy Policy', href: '/terms-conditions' },
    ],
  },
];

export const GROUP = [
  { label: 'Boost Marketing', href: 'https://www.marketwithboost.com/' },
  { label: 'Harry', href: 'https://www.useharry.com/' },
];

export const LOGO = {
  blue: '/marketing/logos/Shopstar Primary Logo Blue.svg',
  white: '/marketing/logos/Shopstar Primary Logo White.svg',
  iconBlue: '/marketing/logos/Shopstar Icon Blue.svg',
  iconWhite: '/marketing/logos/Shopstar Icon White.svg',
};
